import { createSelector } from '@reduxjs/toolkit';

export const selectProgram = state => state.app.program;

export const selectCurrentProgramId = createSelector(
  selectProgram,
  program => program.current,
);
